/* eslint-disable */

export enum AddressServiceType {
	Unknown = -1,
	Manual = 0,
	Svea = 1,
	Eighteen81 = 2,
	
}
